export function personDeadlineBuckets(stats, completedInPeriod = 0) {
  const { abertas = 0, atrasadas = 0, hoje = 0, proximas = 0, sem_prazo = 0 } = stats || {}
  return [
    { id: 'atrasadas', label: 'Atrasadas', count: atrasadas, color: '#ef6464' },
    { id: 'hoje', label: 'Vencem hoje', count: hoje, color: '#eba245' },
    { id: 'proximas_sem_hoje', label: 'Próximos 7 dias', count: Math.max(0, proximas - hoje), color: '#5285ed' },
    { id: 'futuras', label: 'Mais adiante', count: Math.max(0, abertas - atrasadas - proximas - sem_prazo), color: '#94a3b8' },
    { id: 'sem_prazo', label: 'Sem prazo', count: sem_prazo, color: '#c2c9d4' },
    { id: 'concluidas', label: 'Concluídas', count: completedInPeriod, color: '#12a875' },
  ]
}
